export default {
  title: 'Zamknij dostępność',
  close_availabilities_form: {
    date_range: {
      label: 'Wybierz datę i godzinę.',
    },
  },
  reason: {
    label: 'Dodaj powód (opcjonalnie)',
    placeholder: 'Wprowadź opis...',
  },
  recurring: {
    label: 'Powtarza się co roku',
  },
  buttons: {
    save: 'Zapisz',
    cancel: 'Anuluj',
    add: '+ Dodaj wyjątek',
    reactivate: 'Reaktywuj',
  },
  reservations: {
    title: 'Rezerwacje',
    description: 'Czy chcesz dodać wyjątek harmonogramu do rezerwacji?',
    add: 'Dodaj',
    cancel: 'Anuluj',
  },
  projects: {
    online_shop: 'Sklep internetowy',
    reservations: 'Rezerwacje',
    storefront: 'Witryna',
  },
  success_messages: {
    reservation_updated: 'Pomyślnie dodano wyjątek harmonogramu',
  },
  error_messages: {
    date_range_required: 'Wybierz zakres dat.',
    creation_failed: 'Nie udało się utworzyć wyjątku',
    overlapping_schedule_exception: 'Masz już wyjątek harmonogramu dla tego zakresu czasu',
    merge_schedule_exceptions:
      'Następujący wyjątek harmonogramu {{oldDate}} zostanie scalony z {{newDate}}. Możesz również zaktualizować zakres dat dla {{oldDate}}.',
  },
};
